import * as React from 'react';
import ISettings from './ISettings';

interface IProps {
    settings: ISettings
}

export default class Widget extends React.Component<IProps, void> {
    render() {
        return (
            <div className="se-pagebreak-after"></div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/pagebreak/Widget.tsx